// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles_modalDialog__1Qf4U","closeIcon":"styles_closeIcon__2fqCS"};